import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import API_BASE_URL from '../../../../config/api'
import axios from 'axios'
import Topbar from '../../mini-comp/Topbar'
import Sidebar from '../../mini-comp/Sidebar'

const LeaveHistory = () => {
  return (
    <div>
        <Topbar />
        <Sidebar />
    </div>
  )
}

export default LeaveHistory